<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Blogging as a recruiting tool</h1>
                <span class="meta"> Posted in December 2021 </span>


                <figure>
                  <img class="img-fluid" src="img/blog/card/bloggingrecruiting_bw.png" alt="">
                </figure>
                
                <p>During a return visit to France last month, I caught up with a successful French entrepreneur (whom I wish I would have backed on his first venture, but that's another story). Anyway, he opened the conversation with flattery, claiming that I had inspired him. So of course I’m growing suspicious at this point, either expecting a punch line or reconsidering my assessment of his sound judgment. But he wasn’t joking. Rather, he stated that a blog post I wrote several years ago inspired him to adopt a habit which has now given his company a competitive advantage in recruiting talent.</p>

                <p>Specifically, he was referring to something that I had written way back in 2013: <a href="http://rude.vc/ewx7">The importance of blogging for entrepreneurs.</a></p>

                <p>As I posited back then, regular blogging is about far more than shameless self-promotion; it’s about communication of thoughts, transparency in opinions, and beta-testing ideas with the sounding board of your readers. Regular blogging exercises the muscles of intuition and creativity. It facilitates achieving clarity in your mind's eye, and it establishes you as a thought leader in your domain.</p>

                <p>The fifth benefit I had cited in particular has proven especially relevant to this French entrepreneur I caught up with. Consistent blogging over the years is paying dividends to him now as his most effective recruiting tool.</p>

                <p>The market for hiring talent, especially software developers, is insanely competitive right now across Europe, he told me. Startups are finding themselves outbid for developers by deep-pocketed incumbent companies, or increasingly, by other startups who have recently closed on massive fundraising rounds.</p>
                
                <p>By having established his voice over the years through blogging, this guy inadvertently compiled a loyal following of readers who subscribe to the narrative of his ambition. Now, when he posts a job opening, he benefits from a ready-made audience. Better yet, candidates from this audience often prove to fit well culturally, because they've already been indoctrinated into his company's vision over the years.</p>

                <p>Blogging is playing a long game. The fruits of it do not appear immediately, causing many people to abandon it prematurely. Yet this entrepreneur is now reaping the rewards of his long-term investment. Given today’s war for talent, by accelerating the recruiting process and attracting individuals who are already on board with his project, the returns are astronomical.</p>

                <p>Granted, the world has changed in the 8 years since I originally wrote that piece on the powers of blogging. There are other ways to evangelize and build a following as an entrepreneur. Podcasting, for example.</p>

                <p>Creating something that does not rely on the approval of others can offer limitless upside. Naval Ravikant refers to this concept as permissionless leverage.</p>

                <p>
                  <blockquote class="twitter-tweet">
                    <p lang="en" dir="ltr">Code and media are permissionless leverage. They&#39;re the leverage behind the newly rich. You can create software and media that works for you while you sleep.</p>
                    &mdash; Naval (@naval) <a href="https://twitter.com/naval/status/1002106893265920000?ref_src=twsrc%5Etfw">May 31, 2018</a>
                  </blockquote>
                </p>

                <p>I like this articulation and will adopt it too.</p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
